import type { CapturedNetworkRequest } from 'posthog-js'

// Matches a batched URL too (/api/trpc/mcpToken.list,mcpToken.create?batch=1).
const SECRET_BODY_PROCEDURES = ['mcpToken.create']

// Session replay's network capture records request and response bodies,
// which for mcpToken.create includes the raw token. ph-no-capture on the
// reveal dialog covers only its DOM.
export function maskSecretNetworkBodies(
  request: CapturedNetworkRequest,
): CapturedNetworkRequest {
  if (!SECRET_BODY_PROCEDURES.some((path) => request.name.includes(path))) {
    return request
  }
  return { ...request, requestBody: null, responseBody: null }
}
